<script>
import card from "@/components/generic/card";
import services_hebergement from "@/components/landing_components/services_hebergement";

export default {
  components: {card, services_hebergement}
}
</script>
<template>
  <div class="container-fluid base-container text-center">
    <p class="accroche" v-html="$t('hosting.main_title')"></p>
    <p class="subtext">{{ $t('hosting.subtext') }}</p>

    <div class="container-fluid " style="text-align: justify; max-width: 1400px;">
      <p class="normal">{{ $t('hosting.preshot') }}</p>
    </div>

    <div class="row">
      <card orientation="left" icon="fas fa-network-wired"
            :text="$t('hosting.cards.mmr.content')"
            :title="$t('hosting.cards.mmr.title')"/>

      <card orientation="middle" icon="fas fa-server"
            :text="$t('hosting.cards.mutualisation.content')"
            :title="$t('hosting.cards.mutualisation.title')"/>

      <card orientation="right" icon="fas fa-warehouse"
            :text="$t('hosting.cards.dedicated.content')"
            :title="$t('hosting.cards.dedicated.title')"/>
    </div>

    <div class="container-fluid text-center green-banner row3">
      <div class="row2">
        <div class="hideifmobile"><img src="/images/LaCitadelle_badge1422.webp"/>
        </div>
        <div><img src="/images/LaCitadelle_couloirtechnique4e65.webp"/>
        </div>
        <div class="hideifmobile"><img src="/images/LaCitadelle_enviro3-1cfd9.webp"/>
        </div>
      </div>
    </div>

    <p class="accroche" style="margin-top: 75px;" v-html="$t('hosting.services_title')"></p>
    <services_hebergement/>


    <div class="container-fluid text-center green-banner row3" style=" margin-bottom: 75px; margin-top: 75px;">
      <div class="row2">
        <div class="hideifmobile"><img src="/images/LaCitadelle_cameradffb.webp"/>
        </div>
        <div><img src="/images/LaCitadelle_cageprivative2f9a.webp"/>
        </div>
        <div class="hideifmobile"><img src="/images/LaCitadelle_locauxtelecom32c5.webp"/>
        </div>
      </div>
    </div>

    <p class="accroche" style="margin-top: 75px;" v-html="$t('hosting.neutrality_title')"></p>

    <div class="cloud-part">

      <div class="cloud-txt">

        <p>{{ $t('hosting.certifications_pretext') }}</p>
        <div v-html="$t('generics.certifications')"></div>
        <p>{{ $t('hosting.equipment_neutrality') }}</p>
        <p>{{ $t('hosting.national_security') }}</p>

      </div>
    </div>

    <div class="cloud-img">
      <div>
        <img src="/images/iso27001.webp" :alt="$t('landing_components.expertises.alt_img.iso27001')">
      </div>
      <div>
        <img src="/images/hds.webp" :alt="$t('landing_components.expertises.alt_img.hds')">
      </div>
    </div>

  </div>
</template>


<style scoped>

.cloud-img {
  display: flex;
  flex-direction: row;
  justify-content: space-evenly;
  width: 60%;
  max-width: 1100px;
  margin: -80px auto 0;
}

.cloud-part {
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding-bottom: 120px;

}

.cloud-part .cloud-img {
  padding-right: 60px;
}

.cloud-part .cloud-txt {
  color: #f7f7f7;
  text-align: left;
  font-size: 18px;
}

.cloud-txt {
  max-width: 1000px;
  text-align: justify;
}

.cloud-txt h3 {
  padding-left: 20px;
}

.cloud-txt p {
  padding-top: 20px;
  text-align: justify;
}


.green-banner {
  background: #33e091;
  padding: 40px 0;
}

.green-banner p {
  font-size: 24px;
  font-family: 'Prompt', sans-serif;
  font-weight: bold;
  color: #012f2d;
  margin-bottom: 0
}

.row3 {
  max-width: 100%;
  margin: 0;
}

.row2 {
  display: flex;
  justify-content: space-evenly;
  max-width: 80%;
  margin: 0 auto;
}

h3, h4, ul, li {
  color: #f7f7f7;
}


.icon {
  font-size: 48px;
  padding-bottom: 25px;
  color: rgb(51, 224, 145);
}

.normal {
  font-size: 18px;
  color: #f7f7f7
}

pre {
  margin: 50px;
}

.base-container {
  background-image: linear-gradient(180deg, rgba(0, 0, 0, 0.7), rgba(0, 0, 0, 0.1)), url('/images/bg1.webp');
  background-attachment: fixed;
  padding-top: 100px;
  padding-bottom: 100px
}

.base-container .subtext {
  font-size: 24px;
  font-family: 'Prompt', sans-serif;
  color: #f7f7f7;
  margin-bottom: 70px;
}

.base-container .subtext_end {
  font-size: 24px;
  font-family: 'Prompt', sans-serif;
  color: #f7f7f7;
  margin-top: 50px;
  margin-bottom: 40px;
}

.row {
  width: 70%;
  margin: 0 auto;
}


.bottom-footer-area a {
  color: #ccc;
}

.bottom-footer-area a:hover, .bottom-footer-area a:active {
  color: #ddd;
}

.useful-links {
  font-family: 'Prompt', sans-serif;
  color: #f7f7f7;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 40px;
}

.useful-links .row {
  padding: 40px 20px;
}

.my-bottom {
  display: flex;
  flex-direction: row;
  vertical-align: middle;
  justify-content: center;
  font-size: 18px;
}

.bottom-first {
  padding-right: 60px;
  border-right: 1px solid #f7f7f7;
}

.subtext {
  margin-top: -50px
}

@media screen and (max-width: 1080px) {
  .row {
    display: flex;
    flex-direction: column;
  }

  .hideifmobile {
    display: none;
  }

  .my-bottom {
    flex-direction: column;
  }

  .bottom-first {
    border-right: 0;
  }
}
</style>
